// Ventes.js
import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import './Locations.css';
import './Ventes.css';
import { Link } from 'react-router-dom';
import { stripHtml } from '../utils/stripHtml';

function Ventes({
  locations = [],
  page,
  totalPages,
  onPageChange,
  onCategoryChange,
  onLocalisationChange,
  onMinPriceChange,
  onMaxPriceChange,
  minPrice,
  maxPrice,
  category,
  localisation,
  onSortChange,
  onSearchChange,
  onSearchClick
}) {

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          disabled={i === page}
          className={`pagination-number ${i === page ? 'active' : ''}`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="pagination-container">
        <button className="pagination-btn" onClick={() => onPageChange(1)} disabled={page === 1}>&#171;</button>
        <button className="pagination-btn" onClick={() => onPageChange(page - 1)} disabled={page === 1}>&#8249;</button>
        {pages}
        <button className="pagination-btn" onClick={() => onPageChange(page + 1)} disabled={page === totalPages}>&#8250;</button>
        <button className="pagination-btn" onClick={() => onPageChange(totalPages)} disabled={page === totalPages}>&#187;</button>
      </div>
    );
  };

  return (
    <div className="locations-container">
      {/* Filtres */}
      <div className="filters-container">
        <div className="filter-item">
          <select onChange={(e) => onCategoryChange(e.target.value)} value={category}>
            <option value="">Toutes les catégories</option>
            <option value="Terrains">Terrains</option>
            <option value="Appartements">Appartements</option>
            <option value="Maisons">Maisons</option>
            <option value="Champs">Champs</option>
          </select>
        </div>
        <div className="filter-item">
          <input type="text" placeholder="Localisation" value={localisation} onChange={(e) => onLocalisationChange(e.target.value)} />
        </div>
        <div className="filter-item">
          <select onChange={(e) => onSortChange(e.target.value)}>
            <option value="">Trier par prix</option>
            <option value="asc">Prix croissant</option>
            <option value="desc">Prix décroissant</option>
          </select>
        </div>
        <div className="filter-item">
          <input type="number" placeholder="Prix max" value={maxPrice} onChange={(e) => onMaxPriceChange(e.target.value)} />
        </div>
        <div className="filter-item">
          <input type="text" placeholder="Rechercher..." onChange={(e) => onSearchChange(e.target.value)} />
        </div>
        <div className="filter-item">
          <button className="btn-search" onClick={onSearchClick}>Rechercher</button>
        </div>
      </div>

      {/* Liste des ventes */}
      {locations.length > 0 ? (
        locations.map((sale) => (
          <div className="location-card" key={sale._id}>
            <div className="location-image">
              <Splide
                options={{
                  type: 'loop',
                  perPage: 1,
                  pagination: true,
                  autoplay: true,
                  pauseOnHover: true,
                  arrows: true,
                  interval: 3000,
                  speed: 1000,
                }}
                className="splide-carousel"
              >
                {sale.images?.map((imgObj, index) => (
                  <SplideSlide key={index}>
                    <Link to={`/ventes/detail/${sale._id}`}>
                      <img src={imgObj.url} alt={`Slide ${index + 1}`} />
                    </Link>
                  </SplideSlide>
                ))}
              </Splide>
            </div>
            <div className="location-details-l">
              <Link to={`/ventes/detail/${sale._id}`}>
                <h2>{sale.title}</h2>
              </Link>
              <p className="location-icon-l"><i className="fas fa-map-marker-alt"></i> {sale.localisation?.name}</p>
              <div className="location-category-l">
                <p>{sale.category}</p>
                <div className="location-features">
                  <p className="location-description-full">
                    {stripHtml(sale.description)}
                  </p>
                </div>
              </div>

              <div className="location-actions-price">
                <div className="location-actions">
                  <button className="btn-call" onClick={() => window.location.href = "https://wa.me/2217767599067"}>
                    Contacter
                  </button>
                  <Link to="/contact">
                    <button className="btn-contact">Contactez</button>
                  </Link>
                </div>
                <div className="location-price-container">
                  <p className="location-price">
                    {new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(sale.details.price)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>Aucune vente disponible pour le moment.</p>
      )}

      {renderPagination()}
    </div>
  );
}

export default Ventes;
